module.exports = __webpack_public_path__ + "5344223eb9df9bb8719ac824f7c3cf65.png";